import { useQuery } from "@tanstack/react-query"

import type { DateRange } from "../../utils/date-ranges"

import { getCosts, getCostsByUser, getTokenMetrics } from "@/api/admin-api"

import { adminQueryKeys } from "../admin-query-keys"
import { GC_TIME, MEDIUM_STALE_TIME, SLOW_STALE_TIME } from "./_shared"

export function useAdminTokenMetricsQuery(
  range: DateRange | 7 | 30,
  enabled: boolean,
  currency: "SEK" | "USD" | "EUR" = "USD"
) {
  return useQuery({
    queryKey: [...adminQueryKeys.tokenMetrics(range), currency],
    queryFn: () => getTokenMetrics(range, currency),
    enabled,
    staleTime: SLOW_STALE_TIME,
    gcTime: GC_TIME,
    refetchOnWindowFocus: false,
  })
}

export function useAdminCostsQuery(range: DateRange | 7 | 30, enabled: boolean) {
  return useQuery({
    queryKey: adminQueryKeys.costs(range),
    queryFn: () => getCosts(range),
    enabled,
    staleTime: MEDIUM_STALE_TIME,
    gcTime: GC_TIME,
    refetchOnWindowFocus: false,
    placeholderData: (previousData) => previousData,
  })
}

export function useAdminCostsByUserQuery(
  range: DateRange | 7 | 30,
  enabled: boolean,
  currency: "SEK" | "USD" | "EUR" = "USD"
) {
  return useQuery({
    queryKey: [...adminQueryKeys.costsByUser(range), currency],
    queryFn: () => getCostsByUser(range, currency),
    enabled,
    staleTime: MEDIUM_STALE_TIME,
    gcTime: GC_TIME,
    refetchOnWindowFocus: false,
    placeholderData: (previousData) => previousData,
  })
}
